/*
 * Productos relacionados (Related products) — réplica de Capelli USA.
 *
 * En la página de producto la sección ya trae un FALLBACK de catálogo renderizado
 * server-side (para que en la dev store, sin señal de recomendaciones, se vea
 * poblado). Este script pide las recomendaciones REALES a la Product
 * Recommendations API (Section Rendering) y, si devuelven productos, reemplaza el
 * fallback. Luego arma el carrusel (flechas cuadradas que aparecen on hover).
 *
 *   GET {routes.product_recommendations_url}?product_id=..&section_id=..&intent=related&limit=..
 */
(function () {
  function handleFromHref(el) {
    var a = el.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  class RelatedProducts extends HTMLElement {
    connectedCallback() {
      this.loadRecommendations();
      // El fallback ya está en el DOM: arma el carrusel de inmediato.
      this.setupCarousel();
    }

    get grid() {
      return this.querySelector('[data-related-grid]');
    }

    loadRecommendations() {
      var self = this;
      var base = this.dataset.url;
      var productId = this.dataset.productId;
      var sectionId = this.dataset.sectionId;
      var intent = this.dataset.intent || 'related';
      var max = this.dataset.max || '8';
      if (!base || !productId || !sectionId) return;

      var url = base + '?product_id=' + encodeURIComponent(productId) +
        '&section_id=' + encodeURIComponent(sectionId) +
        '&intent=' + encodeURIComponent(intent) +
        '&limit=' + encodeURIComponent(max);

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fetchedGrid = doc.querySelector('[data-related-grid]');
          if (!fetchedGrid) return; // sin recomendaciones: se mantiene el fallback
          var items = Array.prototype.slice.call(fetchedGrid.querySelectorAll('.related__item'));
          if (!items.length) return; // idem
          var grid = self.grid;
          if (!grid) return;
          // Evitar duplicar el producto actual si apareciera
          var current = self.dataset.currentHandle;
          grid.innerHTML = '';
          items.forEach(function (it) {
            if (current && handleFromHref(it) === current) return;
            grid.appendChild(it);
          });
          self.setupCarousel();
        })
        .catch(function () { /* se mantiene el fallback */ });
    }

    // Carrusel: flechas que hacen scroll por vista + centrado vertical sobre la imagen.
    setupCarousel() {
      var self = this;
      var grid = this.grid;
      var prev = this.querySelector('.related__arrow--prev');
      var next = this.querySelector('.related__arrow--next');
      if (!grid || !prev || !next) return;

      // Barra indicadora de desplazamiento (track gris + thumb negro), estilo Capelli.
      var viewport = this.querySelector('.related__viewport');
      var progress = this.querySelector('.related__progress');
      if (!progress && viewport) {
        progress = document.createElement('div');
        progress.className = 'related__progress';
        progress.innerHTML = '<span class="related__progress-thumb"></span>';
        viewport.appendChild(progress);
      }
      var thumb = progress ? progress.querySelector('.related__progress-thumb') : null;

      function centerArrows() {
        var media = grid.querySelector('.resource-card__media') || grid.querySelector('.related__item');
        if (media && media.offsetHeight) {
          self.style.setProperty('--rel-arrow-top', (media.offsetHeight / 2) + 'px');
        }
      }
      function update() {
        var maxScroll = grid.scrollWidth - grid.clientWidth - 1;
        var carousel = grid.scrollWidth > grid.clientWidth + 1;
        prev.hidden = !carousel || grid.scrollLeft <= 0;
        next.hidden = !carousel || grid.scrollLeft >= maxScroll;
        if (progress && thumb) {
          if (carousel) {
            progress.style.display = '';
            // Relleno desde la izquierda (estilo Capelli): el negro = porción total ya vista
            // (borde derecho del viewport / total). Inicio ~visible%, final 100%.
            var wPct = Math.min(100, ((grid.scrollLeft + grid.clientWidth) / grid.scrollWidth) * 100);
            thumb.style.left = '0';
            thumb.style.width = wPct + '%';
          } else {
            progress.style.display = 'none';
          }
        }
      }

      if (!this._wired) {
        prev.addEventListener('click', function () {
          grid.scrollBy({ left: -grid.clientWidth, behavior: 'smooth' });
        });
        next.addEventListener('click', function () {
          grid.scrollBy({ left: grid.clientWidth, behavior: 'smooth' });
        });
        grid.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', function () { centerArrows(); update(); });
        this._wired = true;
      }

      centerArrows();
      update();
      setTimeout(function () { centerArrows(); update(); }, 300);
    }
  }

  if (!customElements.get('related-products')) {
    customElements.define('related-products', RelatedProducts);
  }
})();
